import { SortingState } from "@tanstack/react-table";

import {
  DEFAULT_VOUCHER_SORT,
  SortDirection,
  VOUCHER_SORT_COLUMNS,
  VOUCHER_SORT_DEFAULT_DESC,
  VoucherSortColumn,
} from "./constants";

export type { SortDirection, VoucherSortColumn };

export interface VoucherSorting {
  sort?: VoucherSortColumn;
  direction?: SortDirection;
}

const DESCENDING: SortDirection = "desc";
const ASCENDING: SortDirection = "asc";

const isSortable = (columnId: string): columnId is VoucherSortColumn =>
  VOUCHER_SORT_COLUMNS.includes(columnId as VoucherSortColumn);

export const toVoucherSorting = (state: SortingState): VoucherSorting => {
  const first: SortingState[number] | undefined = state[0];

  if (!first) return {};
  if (!isSortable(first.id)) return {};

  return {
    sort: first.id,
    direction: first.desc ? DESCENDING : ASCENDING,
  };
};

export const toVoucherSortingState = (
  sorting: VoucherSorting,
): SortingState => {
  const column: VoucherSortColumn = sorting.sort ?? DEFAULT_VOUCHER_SORT;
  const desc: boolean = sorting.direction
    ? sorting.direction === DESCENDING
    : VOUCHER_SORT_DEFAULT_DESC[column];

  return [{ id: column, desc }];
};
